import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import SessionContext from '../../../../library/Core/SessionContext';
import ProfileMarkerService from './admin/ProfileMarker/ProfileMakerService';
import Ability from './admin/ProfileMarker/Ability';
import Willingness from './admin/ProfileMarker/Willingness';
import Interests from './admin/ProfileMarker/Interests';
import ProfileMarker from './admin/ProfileMarker/ProfileMarker';
import OfficeUsageNew from './OfficeUsageNew';
import OutreachLog from './OutreachLog';

const OfficeMarker = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    // const { fetchUserProfileMarkers } = ProfileMarkerService();

    const navigate = useNavigate();
    const [isPersonate, setIsPersonate] = useState(sessionStorage.getItem('is-impersonated-session') === 'YES');
    const [activeMarkerTab, setActiveMarkerTab] = useState('outreach-log');

    // useEffect(() => {
    //     const fetchUserMarkers = async () => {
    //         const userMarkers = await fetchUserProfileMarkers(state?.internal?.model?.id);
    //     };
    //     fetchUserMarkers();
    // }, []);

    const renderActiveTab = () => {
        switch (activeMarkerTab) {
            case 'outreach-log':
                return <OutreachLog />;
            case 'office-usage':
                return <OfficeUsageNew />;
            case 'profile-marker':
                return <ProfileMarker />;
            default:
                return <OutreachLog />;
        }
    };

    return (
        <div className="border-d2d2d2 border-radius-6 bg-white overflow-hidden">
            <div className="block-content">
                <div className="block-custom-tab m-0">
                    <ul className="nav nav-pills mt-4 border-bottom" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeMarkerTab === 'outreach-log' ? 'active' : ''}`}
                                id="pills-outreach-log-tab"
                                type="button"
                                role="tab"
                                aria-controls="pills-outreach-log"
                                aria-selected={activeMarkerTab === 'outreach-log'}
                                onClick={() => setActiveMarkerTab('outreach-log')}>
                                OUTREACH LOG
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeMarkerTab === 'profile-marker' ? 'active' : ''}`}
                                id="pills-profile-marker-tab"
                                type="button"
                                role="tab"
                                aria-controls="pills-profile-marker"
                                aria-selected={activeMarkerTab === 'profile-marker'}
                                onClick={() => setActiveMarkerTab('profile-marker')}>
                                PROFILE MARKER
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        {activeMarkerTab === 'outreach-log' && <OutreachLog />}
                        {activeMarkerTab === 'profile-marker' && <ProfileMarker />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfficeMarker;
